import React from 'react';
import PdfPlaceholder from './PdfPlaceholder';
import PdfViewer from './PdfViewer';

interface PdfRightSectionProps {
  base64Pdf?: string;
}

const PdfRightSection: React.FC<PdfRightSectionProps> = ({ base64Pdf }) => {
  return (
    <div className="h-full w-full overflow-hidden">
      {base64Pdf ? (
        <PdfViewer base64Data={base64Pdf} />
      ) : (
        <PdfPlaceholder />
      )}
    </div>
  );
};

export default PdfRightSection;
